import { useQuery } from '@tanstack/react-query'

import { uploadPolicyApi } from '../../data/api/uploadPolicy.api'
import type { UploadWorkflow } from '../models/UploadPolicy'

export const uploadPolicyKeys = {
  byWorkflow: (workflow: UploadWorkflow) => ['uploadPolicy', workflow] as const,
}

export function useUploadPolicy(workflow: UploadWorkflow) {
  return useQuery({
    queryKey: uploadPolicyKeys.byWorkflow(workflow),
    queryFn: async () => {
      const { data } = await uploadPolicyApi.get()
      return data[workflow]
    },
  })
}